import React from 'react';
import { Tooltip as MaterialTooltip, TooltipProps } from '@material-ui/core';

type Props = Omit<TooltipProps, 'arrow'> & { title: string };

function Tooltip({ title, children, ...other }: Props): JSX.Element {
  if (title) {
    return (
      <MaterialTooltip arrow title={title} {...other}>
        {children}
      </MaterialTooltip>
    );
  }
  return <>{children}</>;
}

export default Tooltip;
